import { render, staticRenderFns } from "./copy-workpackage-dialog.vue?vue&type=template&id=b2ad4e02"
import script from "./copy-workpackage-dialog.vue?vue&type=script&lang=js"
export * from "./copy-workpackage-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports